// src/components/Profiles.js
import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";

const Profiles = () => {
  const { user } = useContext(AuthContext);
  const [profiles, setProfiles] = useState([]);

  useEffect(() => {
    const fetchProfiles = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`http://localhost:5000/api/profiles/vendor`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setProfiles(res.data);
      } catch (err) {
        console.error("Error fetching profiles:", err);
      }
    };

    fetchProfiles();
  }, []);

  return (
    <div>
      <h2>Vendor Profiles</h2>
      {profiles.map((profile) => (
        <div key={profile._id} style={{ border: "1px solid #ddd", marginBottom: "10px", padding: "10px" }}>
          <h3>{profile.name}</h3>
          <p><strong>Email:</strong> {profile.email}</p>
          <p><strong>Phone:</strong> {profile.phone}</p>
          <p><strong>Location:</strong> {profile.location}</p>
          <p><strong>Bio:</strong> {profile.bio}</p>
        </div>
      ))}
    </div>
  );
};

export default Profiles;
